import type { TeamMember } from '@api'
import qs from 'query-string'

import type { Creator } from '@/modules/creators/types.ts'
import { apiClientChatting } from '@/utils/axios'

import type {
  GetMassMessagesStatisticsRequestOptions,
  GetMassMessagesStatisticsResponse,
  MassMessage,
  MessageSendRequest,
} from '../types'

const STATS_FETCH_SIZE = 20

const getMassMessagesStatistics = ({
  creatorId,
  page,
  query,
  endDate,
}: GetMassMessagesStatisticsRequestOptions) => {
  const offset = page * STATS_FETCH_SIZE
  const queryString = qs.stringify(
    query
      ? {
          offset,
          query,
        }
      : {
          offset: 0,
          endDate,
        },
    {
      skipNull: true,
      skipEmptyString: true,
    },
  )

  return apiClientChatting
    .get<GetMassMessagesStatisticsResponse>(
      `/of-chat/${creatorId}/mass-message/stats?${queryString}`,
    )
    .then((res) => res.data)
}

const sendMassMessage = (
  creatorId: number,
  message: Partial<MessageSendRequest>,
) => {
  return apiClientChatting
    .post(`/of-chat/${creatorId}/massMessage`, message)
    .then((res) => res.data)
}

const reassignMember = (
  creatorId: Creator['id'],
  userId: TeamMember['userId'],
  massMessageId: number,
): Promise<void> =>
  apiClientChatting.post(`/of-chat/${creatorId}/massMessage/assign`, {
    userId,
    massMessageId,
  })

const unsendMassMessage = (
  creatorId: number,
  massMessageId: MassMessage['id'],
): Promise<void> => {
  return apiClientChatting.delete(
    `/of-chat/${creatorId}/massMessage/${massMessageId}`,
  )
}

export const massMessagesService = {
  getMassMessagesStatistics,
  sendMassMessage,
  reassignMember,
  unsendMassMessage,
}
